import React from "react";
import PropTypes from "prop-types";

import {Box} from "@mui/material";

import MobileCarousel from "components/MobileCarousel";
import MissedTurnoverCard from "./components/MissedTurnoverCard";
import LostTurnoverCard from "./components/LostTurnoverCard";
import EffectiveTurnoverCard from "./components/EffectiveTurnoverCard";

function SecondaryKpis({ ordersData, loading, currency, hasSyliusStockAlertFeature = false }) {
    const cardEffective = (
        <EffectiveTurnoverCard
            value={ordersData?.effectiveTurnover ?? null}
            currency={currency}
            loading={loading}
        />
    );
    const cardLost = (
        <LostTurnoverCard
            value={ordersData?.lostTurnover ?? null}
            currency={currency}
            loading={loading}
        />
    );
    const cardMissed = (
        <MissedTurnoverCard
            value={ordersData?.missedTurnover ?? null}
            currency={currency}
            loading={loading}
            hasSyliusStockAlertFeature={hasSyliusStockAlertFeature}
        />
    );

    return (
        <>
            <MobileCarousel>
                {cardEffective}
                {cardLost}
                {cardMissed}
            </MobileCarousel>

            <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: "row", gap: 2 }}>
                {cardEffective}
                {cardLost}
                {cardMissed}
            </Box>
        </>
    );
}

SecondaryKpis.propTypes = {
    ordersData: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    hasSyliusStockAlertFeature: PropTypes.bool,
};

export default SecondaryKpis;
